import React from "react";
import { useSelector } from "react-redux";
import AllExpenses from "../all-expenses";
import ExpensesDetails from "../expenses-details";
import IncomeDetails from "../income-details";
import CurrencySelectBox from "./CurrencySelectBox";
import DashboardMainHeader from "./DashboardMainHeader";

const RightSideWrapperDB = ({ children }) => {
  const type = useSelector((state) => state.dashboard.type);
  return (
    <>
      <div className="dashboard-right-wrapper">
        <div className="row">
          <div className="col-12">
            <DashboardMainHeader />
            {type === "all" && <CurrencySelectBox IS_ALL={true} />}
            {type === "expense" && <ExpensesDetails />}
            {type === "income" && <IncomeDetails />}
            {type === "all" && <AllExpenses />}
          </div>
        </div>
      </div>
    </>
  );
};

export default RightSideWrapperDB;
